import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "../assets/images/logo.svg";
import envelope from "../assets/images/envelope-icon.svg";
import notification from "../assets/images/notification-icon.svg";
import notificationNoRed from "../assets/images/notification-icon-no-red.svg";
import menuImg from "../assets/images/menu-2.svg";
import { useNavigate } from "react-router-dom";
import api from "../utils/api";
import Swal from "sweetalert2";

const Navbar = ({ data, setHasFetchedData }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [UserData, setUserData] = useState(data);
  const [showNotifications, setShowNotifications] = useState(false);
  const navigate = useNavigate();
  const [notificationMsg, setNotificationMsg] = useState("");
  const [notificationMsgStep, setNotificationMsgStep] = useState("");
  const location = useLocation();

  // Function to fetch user data
  const getUser = async () => {
    try {
      setUserData(data);
      const notification = await api.post(
        `/user/notification?action=get_notification`,
        {
          email: data?.email,
        }
      );
      if (notification.status === 200) {
        setNotificationMsg(notification.data.notification);
        setNotificationMsgStep(notification.data.for_step);
        console.log("notification.data", notification.data);
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };
  const markRead = async () => {
    try {
      const notification = await api.post(
        `/user/notification?action=read_message`,
        {
          email: UserData.email,
          notification_number: notificationMsgStep,
        }
      );
      if (notification.status === 200) {
        setNotificationMsg(notification.data.notification);
        console.log("notification.data", notification.data);
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  useEffect(() => {
    if (
      window.location.pathname !== "/login" &&
      window.location.pathname !== "/register"
    ) {
      getUser();
    }
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen((prevState) => !prevState);
  };

  const toggleNotifications = () => {
    setShowNotifications(!showNotifications);
  };
  useEffect(() => {
    const handleClickAnywhere = (event) => {
      if (event.target.id !== "notifications_btn") {
        setShowNotifications(false);
      }
    };

    document.addEventListener("click", handleClickAnywhere);

    return () => {
      document.removeEventListener("click", handleClickAnywhere);
    };
  }, []);
  // Logout Function with SweetAlert Confirmation
  const logOutFn = async () => {
    const result = await Swal.fire({
      title: "האם אתה בטוח?",
      text: "תצא מהחשבון שלך.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "כן, התנתק!",
      cancelButtonText: "ביטול",
    });

    if (result.isConfirmed) {
      try {
        const response = await api.post("/user/logout");
        if (response.status === 200) {
          setHasFetchedData(false)
          localStorage.clear();
          navigate("/login");
          Swal.fire({
            title: "התנתקת!",
            text: "התנתקת בהצלחה.",
            icon: "success",
            confirmButtonText: "בסדר",
          });
        } else {
          Swal.fire("שגיאה", "היציאה מהחשבון נכשלה. אנא נסה שוב.", "error");
        }
      } catch (error) {
        Swal.fire("שגיאה", "משהו השתבש. אנא נסה שוב.", "error");
        console.error("Logout error:", error);
      }
    }
  };

  useEffect(() => {
    if (isMenuOpen) {
      document.body.classList.add("menu-open");
    } else {
      document.body.classList.remove("menu-open");
    }
  }, [isMenuOpen]);
  useEffect(() => {
   setIsMenuOpen(false)
  }, [location]);

  return (
    <div className="navbar d-flex align-items-center justify-content-between">
      <div className="mobile_menu" onClick={toggleMenu}>
        <img src={menuImg} alt="menu-2" />
      </div>
      <Link to="/" className="logo">
        <img src={logo} alt="Brand Logo" />
      </Link>
      <div className="navbar-left">
        <ul className="unlisted d-flex align-items-center">
          <li
            className="profile-info d-flex flex-column"
            style={{ cursor: "pointer" }}
          >
            <Link to="/profile">
              <strong style={{ display: "block" }}>{UserData.full_name}</strong>
            </Link>
          </li>
          {/* Notification Icon */}
          <li
            onClick={toggleNotifications}
            style={{ position: "relative" }}
            title="Notification"
          >
            <img
              src={notificationMsg ? notification : notificationNoRed}
              id="notifications_btn"
              alt="Notification Icon"
              style={{ cursor: "pointer" }}
            />
            {/* Notification Dropdown */}
            {showNotifications && (
              <div className="notification-dropdown">
                <div className="notification-item">
                  {notificationMsg ? (
                    <>
                      <div className="noti-icon">
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clipPath="url(#clip0_67_862)">
                            <path
                              d="M19.3932 13.5395L19.3891 13.5236L18.0782 8.12862C17.6299 8.26029 17.1574 8.33445 16.6666 8.33445C16.5799 8.33445 16.4957 8.32612 16.4099 8.32112L17.7741 13.9336C17.7757 13.9395 17.7799 13.9436 17.7807 13.9503H17.7774C17.8457 14.207 17.7949 14.4628 17.6366 14.672C17.4766 14.8845 17.2399 15.0011 16.9732 15.0011H2.91074C2.65657 15.0011 2.4199 14.887 2.2624 14.692C2.1024 14.492 2.0424 14.2353 2.0899 14.0153L4.0499 6.41779C4.67157 3.62112 7.11824 1.66779 9.9999 1.66779C10.6441 1.66779 11.2691 1.77779 11.8599 1.96862C12.0166 1.41779 12.2632 0.906121 12.5866 0.451121C11.7707 0.161121 10.8991 0.00195396 9.9999 0.00195396C6.33157 0.000287295 3.21574 2.49029 2.4299 6.02779L0.469903 13.627C0.305736 14.3686 0.484903 15.1361 0.962403 15.7336C1.4399 16.327 2.15074 16.667 2.91074 16.667H5.9174C6.3049 18.5661 7.9874 20.0003 9.9999 20.0003C12.0124 20.0003 13.6949 18.5661 14.0824 16.667H16.9741C17.7632 16.667 18.4882 16.3061 18.9657 15.6786C19.4291 15.0678 19.5816 14.2953 19.3941 13.5536C19.3932 13.5486 19.3932 13.5445 19.3932 13.5395ZM9.9999 18.3336C8.9149 18.3336 7.99824 17.6345 7.65324 16.667H12.3457C12.0007 17.6345 11.0849 18.3336 9.9999 18.3336Z"
                              fill="#ADADAD"
                            />
                          </g>
                        </svg>
                      </div>
                      <div>
                        <p>{notificationMsg}</p>
                        <div className="btns-row">
                          <div
                            onClick={markRead}
                            className="btn btn-img noti_btn"
                          >
                            סמן כנקראה
                          </div>
                        </div>
                      </div>
                    </>
                  ) : (
                    <div>אין הודעות חדשות</div>
                  )}
                </div>
              </div>
            )}
          </li>
          <li onClick={logOutFn} style={{ cursor: "pointer" }} title="Logout">
            <img src={envelope} alt="Logout Icon" />
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Navbar;
